import { gql } from 'graphql.macro';
export const deviationsFragment = gql`
    fragment deviationsFields on Deviations {
        _id
        code
        description
        type
        technician
        addedOn
        report
        visibleForDentist
        actions {
            _id
            technician
            addedOn
            report
            visibleForDentist
        }
    }
`;
